module.exports = __webpack_public_path__ + "streamline-24px.c447358634d012ceb1aa.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/strahinja.aparac/Desktop/git/source/healthcare/v2/app/appointment-widget/src/assets/fonts/streamline/streamline-24px.eot
// module id = ../../../../../src/assets/fonts/streamline/streamline-24px.eot
// module chunks = styles